import { render, staticRenderFns } from "./customers0608.vue?vue&type=template&id=01d888b0&scoped=true&"
import script from "./customers0608.vue?vue&type=script&lang=js&"
export * from "./customers0608.vue?vue&type=script&lang=js&"
import style0 from "./customers0608.vue?vue&type=style&index=0&id=01d888b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d888b0",
  null
  
)

export default component.exports